import { useQuery } from '@apollo/client';
import { INVOICE_RECEIPT_URL } from '../../queries';
import ExternalThemeLink from '../ExternalThemeLink';

export default function InvoiceReceiptLink({ invoiceId }) {
  const { loading, error, data } = useQuery(INVOICE_RECEIPT_URL, {
    variables: {
      invoiceId,
    },
  });

  const invoiceReceiptUrl = data?.invoiceReceiptUrl;

  if (error) {
    return null;
  }

  return (
    <div className="relative flex pb-2 px-2">
      {loading && !invoiceReceiptUrl && (
        <div className="absolute inset-0 -top-2 animate-pulse rounded-lg bg-gray-100 pointer-events-none"></div>
      )}

      <ExternalThemeLink
        href={invoiceReceiptUrl}
        rel="noreferrer"
        target="_blank"
      >
        Order Receipt
      </ExternalThemeLink>
    </div>
  );
}
